import { authFetch } from "./authProvider";

const SERVICE_URL = "user-service/v2/organizations/:orgId";

export const resetPassword = async (data, orgId) => {
  let url = SERVICE_URL.replace(":orgId", orgId) + "/reset";
  return await authFetch("post", url, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error.response);
      return error.response;
    });
};

export const sendMail = async (data) => {
  let url = "user-service/v2/forgot-password";
  return await authFetch("post", url, data)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error.response);
      return error.response;
    });
};
